<template>
  <div>
    <div><img
        src="../assets/img/top.png"
        style="width:100%"
        alt=""
      ></div>
    <div class="box">
      <div class="form-box">
        <van-form
          @submit="onSubmit"
          :show-error="false"
        >
          <van-field
            v-model="username"
            name="username"
            label="求助人姓名"
            placeholder="请输入求助人姓名"
            :rules="[{ required: true, message: '请填写求助人姓名' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name="password"
            label="求助人联系电话"
            placeholder="请输入求助人联系电话"
            :rules="[{ required: true, message: '请填写求助人联系电话' }]"
          />
          <van-field
            v-model="verificationCode"
            center
            name="code"
            label="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
            placeholder="请输入验证码"
          >
            <button
              slot="button"
              :disabled="!countdown"
              v-bind:class="[countdown ? 'reg_active' : 'reg_disActive']"
              @click="getCode"
            >
              <span v-if="countdown">{{text}}</span>
              <span v-if="!countdown">{{text}} ({{count}})</span>
            </button>
          </van-field>
          <van-field
            readonly
            clickable
            name="area"
            :value="formData.area"
            label="需援助人员地址"
            placeholder="请选择需援助人员地址"
            @click="showArea = true"
          />
          <van-popup
            v-model="showArea"
            position="bottom"
          >
            <van-area
              :area-list="areaList"
              @confirm="onConfirm"
              @cancel="showArea = false"
            />
          </van-popup>
          <van-field
            v-model="username"
            name="username"
            placeholder="请输入详细地址"
            :rules="[{ required: true, message: '请填写详细地址' }]"
          />
          <van-field
            v-model="username"
            name="username"
            label="具体求助需求"
            placeholder="请输入具体求助需求"
            type="textarea"
            :rules="[{ required: true, message: '请填写具体求助需求' }]"
          />
          <div style="margin: 16px;background:#fff">
            <van-button
              block
              style="border-radius:3px;font-size:16px;font-weight:700"
              type="info"
              native-type="submit"
            >提交</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { submitSituation } from '@/api/epidemicSituation'
export default {
  data () {
    return {
      areaList,
      username: '',
      password: '',
      verificationCode: "",//收到的验证码
      countdown: true,//验证码的状态，默认显示发送验证码
      count: "",//60秒倒计时
      timer: null,
      text: "获取验证码",
      showArea: false,
      formData: {

      }

    };
  },
  methods: {
    onSubmit (values) {
      console.log('submit', values);
    },
    getCode () {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送"
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;

            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    onConfirm (values) {
      this.formData.area = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(',');
      this.showArea = false;
    },
  },
};
</script>

<style scoped>
/deep/.van-field__control {
  border: 1px solid #b8bdc5;
  border-radius: 3px;
  padding: 8px;
}
/deep/.van-field__label {
  width: 100% !important;
  margin-bottom: 6px;
  font-weight: 600;
}
/deep/.van-cell {
  flex-wrap: wrap !important;
  padding-top: 8px;
  padding-bottom: 8px;
}
/deep/.van-cell::after {
  border: 0;
}
.box {
  background: url("../assets/img/background.png") 100% 100% repeat;
  padding: 0 17px;
  margin-top: -20px;
  padding-bottom: 32px;
}
.form-box {
  background: #fff;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  padding: 12px 0;
}

.reg_active {
  color: #276cdd;
  border: 1px solid #276cdd;
  padding: 8px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}
.reg_disActive {
  /* background: #07c160; */
  color: #276cdd;
  border: 1px solid #276cdd;
  padding: 8px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}
</style>